import React from 'react';
import logo from './logo.svg';
import './App.css';
import Home from './pages/home/Home';
import connect, {mapDispatchToProps} from "./store/connect";
import { GlobalStyle, StyledToastContainer } from "./Global.style";
import {withTranslation} from "react-i18next";
import MessageProvider from "./provider/MessageProvider";
import RouterView from "./router/RouterView";
import Header from "./components/header/Header";
import { ToastContainer } from "react-toastify";
import { UseOperator } from "./hooks/UseOperator";
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <div className="App" id="appRoot">
      <GlobalStyle />
      <UseOperator />
      <MessageProvider>
        <Header></Header>
        <RouterView />
      </MessageProvider>
      <StyledToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default withTranslation()(connect(App));
